/*
  Pocket: Lights off (dark mode).

  The switch sits under "Log in" in the mobile menu (sections/header.liquid).
  Flipping it puts data-pocket-lights="off" on <html>, which
  assets/pocket-lights.css uses to swap the theme's base colours for dark ones,
  and remembers the choice on this device. The small script at the top of
  layout/theme.liquid applies a saved choice before the page paints, so there's
  no flash of the light theme on the next page.
*/
(() => {
  const KEY = 'pocket-lights';
  const DARK_THEME_COLOR = '#1b1917'; // the browser bar on phones
  const FADE_MS = 700;

  const root = document.documentElement;
  const meta = document.querySelector('meta[name="theme-color"]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let fadeTimer;

  const lightsAreOff = () => root.getAttribute('data-pocket-lights') === 'off';

  const saved = () => {
    try {
      return localStorage.getItem(KEY) === 'off';
    } catch (e) {
      return lightsAreOff();
    }
  };

  function apply(off, fade) {
    if (fade && !reduceMotion.matches && off !== lightsAreOff()) {
      root.classList.add('pocket-lights-fading');
      clearTimeout(fadeTimer);
      fadeTimer = setTimeout(() => root.classList.remove('pocket-lights-fading'), FADE_MS);
    }
    if (off) {
      root.setAttribute('data-pocket-lights', 'off');
    } else {
      root.removeAttribute('data-pocket-lights');
    }
    if (meta) meta.setAttribute('content', off ? DARK_THEME_COLOR : '');
    document.querySelectorAll('[data-pocket-lights-switch]').forEach((button) => {
      button.setAttribute('aria-checked', String(off));
    });
  }

  // Listens in the capture phase and stops the click there. The menu drawer
  // (assets/global.js) wires every <button> inside it to close the menu, but
  // that path skips unlocking the page scroll, which left the page frozen.
  // Stopping the click keeps the menu open so the lights visibly go off.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-pocket-lights-switch]')) return;
    event.stopPropagation();
    const off = !lightsAreOff();
    apply(off, true);
    try {
      localStorage.setItem(KEY, off ? 'off' : 'on');
    } catch (e) {}
  }, true);

  // Keep other open tabs, and pages restored with the back button, in step.
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) apply(event.newValue === 'off', false);
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) apply(saved(), false);
  });

  apply(lightsAreOff(), false);
})();
